(function ($, Drupal, drupalSettings) {
  $("document").ready(setup);

  function setup() {
    buttonMyProject();
    uploadForm();
    scrollInputCheckOrLoadPage();

    // Formulaire Contact
    if ($(".webform-submission-contact-form").length) {
      initForm(drupalSettings.path.currentLanguage);
    }

    // Formulaire Demande de catalogue
    if ($(".webform-submission-demande-de-catalogue-form").length) {
      initForm(drupalSettings.path.currentLanguage);
    }

    // Formulaire Demande de catalogue
    if ($(".webform-submission-demande-de-devis-form").length) {
      initForm(drupalSettings.path.currentLanguage);
    }

    // Formulaire Landing Page Part / Pro - FR
    if ($(".webform-submission-landing-page-form, .webform-submission-landing-page-pro-form").length) {
      initForm(drupalSettings.path.currentLanguage);
    }

    // Formulaire "Etre rappelé"
    if ($(".webform-submission-webcallback-form").length) {
      initForm(drupalSettings.path.currentLanguage);
    }

    // Formulaire Mon projet
    $(".webform-submission-prise-de-rendez-vous-je-precise--form .webform-button--next").click(verifFormRDV);
    if ($(".webform-submission-prise-de-rendez-vous-je-precise--form .webform-button--submit").length) {
      initForm(drupalSettings.path.currentLanguage);
    }

    datePickerFormRDV();
    $(document).ajaxComplete(function () {
      datePickerFormRDV();
      uploadForm();
      scrollInputCheckOrLoadPage();
      //$(".newsletters input[name$='op']").click(verifFormNewsletter);
    });
  }

  function scrollInputCheckOrLoadPage() {
    if ($("#edit-etape-2-mes-delais").length) {
      $('html, body').animate({
        scrollTop: $("#edit-etape-2-mes-delais").offset().top - 125
      }, 2000);
    }
    if ($("#edit-etape-3-mon-budget").length) {
      $('html, body').animate({
        scrollTop: $("#edit-etape-3-mon-budget").offset().top - 125
      }, 2000);
    }
    if ($("#edit-etape-4-notre-rendez-vous").length) {
      $('html, body').animate({
        scrollTop: $("#edit-etape-4-notre-rendez-vous").offset().top - 125
      }, 2000);
    }
    $($("input[name$='lines_veranda']")).click(function () {
      $('html,body').animate({
        scrollTop: $("#edit-etape-1-title-1").offset().top - 125
      }, 'slow');
    });

    $($("input[name$='choix_de_la_pergola']")).click(function () {
      $('html,body').animate({
        scrollTop: $("#edit-etape-1-title-2").offset().top - 125
      }, 'slow');
    });

    $($("input[name$='choix_de_installation']")).click(function () {
      $('html,body').animate({
        scrollTop: $("#edit-etape-1-title-3").offset().top - 125
      }, 'slow');
    });
  }

  // Fonction qui check pendant un upload d'un fichier
  function uploadForm() {
    $("input[name$='photo_de_la_facade_de_la_maison_upload_button']").hide();
    $("[id^=edit-photo-de-la-facade-de-la-maison-upload]").on("change", function (e) {
        e.preventDefault();
        $("input[id^=edit-photo-de-la-facade-de-la-maison-upload-button]").mousedown();
      }
    );

    $("input[name$='telecharger_votre_opc_upload_button']").hide();
    $("[id^=edit-telecharger-votre-opc-upload]").on("change", function (e) {
        e.preventDefault();
        $("input[id^=edit-telecharger-votre-opc-upload-button]").mousedown();
      }
    );

    $("input[name$='joindre_une_photo_1_upload_button']").hide();
    $("[id^=edit-joindre-une-photo-1-upload]").on("change", function (e) {
        e.preventDefault();
        $("input[id^=edit-joindre-une-photo-1-upload]").mousedown();
      }
    );

    $("input[name$='joindre_une_photo_2_upload_button']").hide();
    $("[id^=edit-joindre-une-photo-2-upload]").on("change", function (e) {
        e.preventDefault();
        $("input[id^=edit-joindre-une-photo-2-upload]").mousedown();
      }
    );

    $("input[name$='joindre_une_photo_3_upload_button']").hide();
    $("[id^=edit-joindre-une-photo-3-upload]").on("change", function (e) {
        e.preventDefault();
        $("input[id^=edit-joindre-une-photo-3-upload]").mousedown();
      }
    );

    $("input[name$='telecharger_une_photo_upload_button']").hide();
    $("[id^=edit-telecharger-une-photo-upload]").on("change", function (e) {
        e.preventDefault();
        $("input[id^=edit-telecharger-une-photo-upload]").mousedown();
      }
    );
  }

  // Fonction Scrool "Accueil" du Formulaire RDV
  function buttonMyProject() {
    $("#my-project").click(function () {
      position = $(".webform-progress-bar").offset().top;
      if ($(window).width() > 1200) {
        positions = position - 100;
      } else {
        positions = position;
      }

      $("html, body").animate(
        {
          scrollTop: positions
        },
        1000
      );
    });
  }

  // Fonction DatePicker Formulaire RDV
  function datePickerFormRDV() {
    if (window.matchMedia("(min-width:1024px)").matches) {
      $(".edit-calendrier-des-rendez-vous-items-0-le").datepicker({
        minDate: new Date(),
        firstDay: 1
      });
      $(".edit-calendrier-des-rendez-vous-items-1-le").datepicker({
        minDate: new Date(),
        firstDay: 1
      });
      $(".edit-calendrier-des-rendez-vous-items-2-le").datepicker({
        minDate: new Date(),
        firstDay: 1
      });
    } else {
      $(".edit-calendrier-des-rendez-vous-items-0-le").removeAttr("readonly");
      $(".edit-calendrier-des-rendez-vous-items-1-le").removeAttr("readonly");
      $(".edit-calendrier-des-rendez-vous-items-2-le").removeAttr("readonly");
    }
  }

  /**************************************************************
   ************** Vérification des formulaires ******************
   **************************************************************/

  function initForm(country) {

    country === 'en' ? country = 'gb' : country;

    var countryData = window.intlTelInputGlobals.getCountryData(),
      input = document.querySelector("#edit-telephone"),
      addressDropdown = document.querySelector("#edit-pays");

    var iti = window.intlTelInput(input, {
      allowDropdown: true,
      separateDialCode: true,
      onlyCountries: ["fr", "be", "ch", "it", "de", "es", "pt", "nl", "lu", "gb"],
      initialCountry: country,
      utilsScript: "/themes/custom/akena/js/libs/intlTelInputUtils.js"
    });


    // Pays change via le telepone
    addressDropdown.value = iti.getSelectedCountryData().iso2;
    input.addEventListener('countrychange', function (e) {
      addressDropdown.value = iti.getSelectedCountryData().iso2;
    });

    // Pays du telephone change via le champ pays
    addressDropdown.addEventListener('change', function () {
      iti.setCountry($("#edit-pays").val());
    });

    $(".webform-submission-landing-page-form .edit-actions-submit").click({iti: iti}, verifFormContact);
    $(".webform-submission-contact-form .edit-actions-submit").click({iti: iti, country: country}, verifFormContact);
    $(".webform-submission-demande-de-devis-form .edit-actions-submit").click({iti: iti, country: country}, verifFormContact);
    $(".webform-submission-demande-de-catalogue-form .edit-actions-submit").click({iti: iti, country: country}, verifFormContact);
    $(".webform-submission-webcallback-form .edit-actions-submit").click({iti: iti, country: country}, verifFormContact);
    $(".webform-submission-prise-de-rendez-vous-je-precise--form .webform-button--submit").click({iti: iti, country: country}, verifFormRDV);
  }

  // Fonction de vérification du formulaire du Rendez-vous sur la Home
  function verifFormStep0RDV(e) {
    var nbChampVide = 0;
    $("div.error").remove();
    $("select.error").removeClass("error");
    $("select.valid").removeClass("valid");
    $("input.error").removeClass("error");
    $("input.form-error").removeClass("form-error");
    $("input.valid").removeClass("valid");

    // Etape 1 - Mon projet
    var total_lines_veranda = $("input[name$='lines_veranda']").length;
    $("input[name$='lines_veranda']").each(function (index) {
      if ($("input[name$='lines_veranda']:checked").length < 1) {
        if (index === total_lines_veranda - 1) {
          $("#edit-lines-veranda--wrapper").before(
            '<div class="error">' +
            $(this).attr("data-webform-required-error") +
            "</div>"
          );
          $(".error").fadeIn();
          nbChampVide++;
        }
      }
    });

    if (nbChampVide != 0) {
      e.preventDefault();
      $("html, body").animate(
        {scrollTop: $(".error").offset().top - 125},
        500
      );
    } else {
    }
  }

  // Fonction de vérification du formulaire du Rendez-vous
  function verifFormRDV(event) {
    var nbChampVide = 0;
    $("div.error").remove();
    $("select.error").removeClass("error");
    $("select.valid").removeClass("valid");
    $("input.error").removeClass("error");
    $("input.form-error").removeClass("form-error");
    $("input.valid").removeClass("valid");
    $(".rgpd-error").remove();

    // Etape 1 - Mon projet
    var total_lines_veranda = $("input[name$='lines_veranda']").length;
    $("input[name$='lines_veranda']").each(function (index) {
      if ($("input[name$='lines_veranda']:checked").length < 1) {
        if (index === total_lines_veranda - 1) {
          $("#edit-lines-veranda--wrapper").before('<div class="error">' + $(this).attr("data-webform-required-error") + "</div>");
          $(".error").fadeIn();
          nbChampVide++;
        }
      }
    });

    var total_choix_de_la_pergola = $("input[name$='choix_de_la_pergola']").length;
    $("input[name$='choix_de_la_pergola']").each(function (index) {
      if ($("input[name$='choix_de_la_pergola']:checked").length < 1) {
        if (index === total_choix_de_la_pergola - 1) {
          $("#edit-choix-de-la-pergola--wrapper").before('<div class="error">' + $(this).attr("data-webform-required-error") + "</div>");
          $(".error").fadeIn();
          nbChampVide++;
        }
      }
    });

    var total_choix_de_installation = $("input[name$='choix_de_installation']").length;
    $("input[name$='choix_de_installation']").each(function (index) {
      if ($("input[name$='choix_de_installation']:checked").length < 1) {
        if (index === total_choix_de_installation - 1) {
          $("#edit-choix-de-installation--wrapper").before('<div class="error">' + $(this).attr("data-webform-required-error") + "</div>");
          $(".error").fadeIn();
          nbChampVide++;
        }
      }
    });

    // Etape 2 - Mes delais
    var total_profiter_de_votre_pergola = $(
      "input[name$='profiter_de_votre_pergola']").length;
    $("input[name$='profiter_de_votre_pergola']").each(function (index) {
      if ($("input[name$='profiter_de_votre_pergola']:checked").length < 1) {
        if (index === total_profiter_de_votre_pergola - 1) {
          $("#edit-profiter-de-votre-pergola--wrapper").before('<div class="error">' + $(this).attr("data-webform-required-error") + "</div>");
          $(".error").fadeIn();
          nbChampVide++;
        }
      }
    });

    // Etape 3 - Mon budget
    var total_choix_du_budget = $("input[name$='choix_du_budget']").length;
    $("input[name$='choix_du_budget']").each(function (index) {
      if ($("input[name$='choix_du_budget']:checked").length < 1) {
        if (index === total_choix_du_budget - 1) {
          $("#edit-choix-du-budget--wrapper").before('<div class="error">' + $(this).attr("data-webform-required-error") + "</div>");
          $(".error").fadeIn();
          nbChampVide++;
        }
      }
    });

    // Liste déroulante Besoin d'un financement
    $("#edit-etape-3-mon-budget select.required").each(function () {
      if ($(this).val() == "" || $(this).val() == " ") {
        $(this).addClass("error");
        $(this).parent().append('<div class="error">' + $(this).attr("data-webform-required-error") + "</div>");
        $(".error").fadeIn();
        nbChampVide++;
      }
    });

    // Etape 4 - Notre rendez-vous
    $("#calendrier_des_rendez_vous_table input:not(.edit-submit)").each(function () {
        if ($(this).attr("required") == "required") {
          var textError = $(this).attr("data-webform-required-error");
          if ($(this).val() == "" || $(this).val() == " ") {
            // On vérifie que le champ n'est pas vide
            nbChampVide++;
            $(this).addClass("error");
            $(this).parent().append("<div class='error'></div>");
            $(".error").fadeIn();
          }
        }
      }
    );

    $("#edit-section-4-etape-4 input:not(.edit-submit)").each(function () {
      if ($(this).attr("required") == "required") {
        var textError = $(this).attr("data-webform-required-error");
        if ($(this).val() == "" || $(this).val() == " ") {
          // On vérifie que le champ n'est pas vide
          nbChampVide++;
          $(this).addClass("form-error");
          $(this).parent().append("<div class='error'>" + textError + "</div>");
          $(".error").fadeIn();
        } else {
          // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
          var name = $(this).attr("name");
          if (name == "email") {
            var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim;
            if (regex.test($(this).val()) == false) {
              nbChampVide++;
              $(this).addClass("form-error");
              var lang = drupalSettings.path.currentLanguage;
              if(lang === 'es'){
                $(this).parent().append("<div class='error'>Por favor, rellene un correo electrónico válido.</div>");
              } else if(lang === 'it'){
                $(this).parent().append("<div class='error'>Inserisci un indirizzo email valido.</div>");
              }else if(lang === 'en'){
                $(this).parent().append("<div class='error'>Please enter a valid email address.</div>");
              } else{
                $(this).parent().append("<div class='error'>Veuillez renseigner une adresse email valide.</div>");
              }
              $(".error").fadeIn();
            } else {
              $(this).addClass("valid");
            }
          } else if (name == "telephone") {
            var iti = event.data.iti;
            var input = document.querySelector("#edit-telephone");
            if (input.value.trim()) {
              // if number is not valid
              if (iti.isValidNumber()) {
                $(this).addClass("valid");
                iti.setNumber(input.value);
                var countryData = iti.getSelectedCountryData();
                $('.edit-telephone-format').val('+' + countryData.dialCode + input.value)
              } else {
                nbChampVide++;
                $(this).addClass("form-error");
                var lang = drupalSettings.path.currentLanguage;
                if ($(this).attr('placeholder')) {
                  if(lang === 'es'){
                    $(this).parent().append("<div class='error'>Por favor, rellene un número de teléfono válido (" + $(this).attr('placeholder') + ")</div>")
                  } else if(lang === 'it'){
                    $(this).parent().append("<div class='error'>Si prega di inserire un numero di telefono valido. (" + $(this).attr('placeholder') + ")</div>")
                  }else if(lang === 'en'){
                    $(this).parent().append("<div class='error'>Please enter a valid telephone number. (" + $(this).attr('placeholder') + ")</div>")
                  } else{
                    $(this).parent().append("<div class='error'>Veuillez renseigner un numéro de téléphone valide. (Exemple : " + $(this).attr('placeholder') + ")</div>");
                  }
                } else {
                  iti.setCountry(event.data.country);
                  $("#edit-pays").val(event.data.country);
                  if(lang === 'es'){
                    $(this).parent().append("<div class='error'>Por favor, rellene un número de teléfono válido. (" + $(this).attr('placeholder') + ")</div>");
                  } else if(lang === 'it'){
                    $(this).parent().append("<div class='error'>Si prega di inserire un numero di telefono valido. (" + $(this).attr('placeholder') + ")</div>");
                  }else if(lang === 'en'){
                    $(this).parent().append("<div class='error'>Please enter a valid telephone number. (" + $(this).attr('placeholder') + ")</div>");
                  } else{
                    $(this).parent().append("<div class='error'>Veuillez renseigner un numéro de téléphone valide. (Exemple : " + $(this).attr('placeholder') + ")</div>");
                  }                }
                $(".error").fadeIn();
              }
            }
          } else if (name == "code_postal") {
            var ISO = $("#edit-pays").val();
            var json = $.getJSON({'url': '/themes/custom/akena/js/libs/postalCode.json', 'async': false});
            apiResponseJsonObj = JSON.parse(json.responseText);
            var regexPostCode = new RegExp(apiResponseJsonObj[0][ISO]['regex']);
            var zipCodeInput = $("#edit-code-postal");

            if (regexPostCode.test($.trim($("#edit-code-postal").val())) == false) {
              nbChampVide++;
              zipCodeInput.addClass("form-error");
              if (event.data.country === 'es') {
                zipCodeInput.parent().append("<div class='error'>Por favor, introduzca un código postal válido. (Ejemplo : " + apiResponseJsonObj[0][ISO]['format'] + ")</div>");
              } else if (event.data.country === 'it') {
                zipCodeInput.parent().append("<div class='error'>Si prega di inserire un codice postale valido. (Esempio : " + apiResponseJsonObj[0][ISO]['format'] + ")</div>");
              }else if (event.data.country === 'en') {
                zipCodeInput.parent().append("<div class='error'>Please enter a valid postcode. (Example : " + apiResponseJsonObj[0][ISO]['format'] + ")</div>");
              } else {
                zipCodeInput.parent().append("<div class='error'>Veuillez renseigner un code postal valide. (Exemple : " + apiResponseJsonObj[0][ISO]['format'] + ")</div>");
              }
              $(".error").fadeIn();
            } else {
              $(this).addClass("valid");
            }
          } else {
            $(this).addClass("valid");
          }
        }
      }
    });

    // On vérifie que reCaptcha
    if ($("input[name$='recapcha']").length) {
      var lang = drupalSettings.path.currentLanguage;
      var recapcha = $("input[name$='recapcha']").val();
      if (recapcha == "true") {
        var $captcha = $(".g-recaptcha"),
          response = grecaptcha.getResponse();
        if (response.length === 0) {
          if(lang === 'es'){
            $(this).parent().append("<div class='error'>Por favor, compruebe el captcha requerido.</div>");
          } else if(lang === 'it'){
            $(this).parent().append("<div class='error'>Seleziona il captcha richiesto.</div>");
          } else if(lang === 'en'){
            $(this).parent().append("<div class='error'>Please check the required captcha.</div>");
          } else{
            $(".g-recaptcha").after("<div class='error'>Veuillez cocher le captcha obligatoire.</div>");
          }
          nbChampVide++;
        } else {
          $(".msg-error").text("");
          $captcha.removeClass("error");
        }
      }
    }

    if ($("[id^=edit-rgpd]").length) {
      var consentment = $("[id^=edit-rgpd]").prop("checked");
      if (consentment === false) {
        if(lang === 'es'){
          $(".form-item-rgpd").after("<div class='rgpd-error'>Por favor, marque la casilla para validar su consentimiento a los datos recogidos.</div>");
        } else if(lang === 'it'){
          $(".form-item-rgpd").after("<div class='rgpd-error'>Seleziona la casella per confermare il tuo consenso alla raccolta dei dati.</div>");
        } else if(lang === 'en'){
          $(".form-item-rgpd").after("<div class='rgpd-error'>Check the box to confirm your consent to data collection.</div>");
        } else{
          $(".form-item-rgpd").after("<div class='rgpd-error'>Merci de cocher la case pour valider votre consentement aux données collectées.</div>");
        }
        nbChampVide++;
      }
    }

    if (nbChampVide != 0) {
      event.preventDefault();
      $("html, body").animate({scrollTop: $(".error").offset().top - 125}, 500);
    } else {
      $("body").addClass("loader");
    }
  }

  // Fonction de vérification du formulaire de Contact Basique
  function verifFormContact(event) {
    //console.log(event.data.country);
    var nbChampVide = 0;
    $("div.error").remove();
    $("select.error").removeClass("error");
    $("select.valid").removeClass("valid");
    $("input.error").removeClass("error");
    $("textarea.error").removeClass("error");
    $("input.form-error").removeClass("form-error");
    $("textarea.form-error").removeClass("form-error");
    $("input.valid").removeClass("valid");
    $(".rgpd-error").remove();
    $(".checkbox-error").remove();

    // On vérifie la saisie des champs obligatoire
    $(".webform-submission-contact-form input:not(.edit-actions-submit), .webform-submission-demand-documentation-ou-devis-form input:not(.edit-actions-submit), .webform-submission-landing-page-form input:not(.edit-actions-submit), .webform-submission-landing-page-pro-form input:not(.edit-actions-submit), .webform-submission-landing-page-pro-es-form input:not(.edit-actions-submit), .webform-submission-demande-de-catalogue-form input:not(.edit-actions-submit), .webform-submission-mon-opc-form input:not(.edit-actions-submit), .webform-submission-devenir-revendeur-form input:not(.edit-actions-submit), .webform-submission-demande-de-devis-form input:not(.edit-actions-submit), .webform-submission-sav-form input:not(.edit-actions-submit), .webform-submission-parrainage-form input:not(.edit-actions-submit), .webform-submission-votre-projet-en-cours-form input:not(.edit-actions-submit), .webform-submission-webcallback-form input:not(.edit-actions-submit)"
    ).each(function () {
      if ($(this).attr("required") == "required") {
        var textError = $(this).attr("data-webform-required-error");
        if ($(this).val() == "" || $(this).val() == " ") {
          // On vérifie que le champ n'est pas vide
          nbChampVide++;
          $(this).addClass("form-error");
          $(this).parent().append("<div class='error'>" + textError + "</div>");
          $(".error").fadeIn();
        } else {
          // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
          var name = $(this).attr("name");
          if (name == "email") {
            var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim;
            if (regex.test($(this).val()) == false) {
              nbChampVide++;
              $(this).addClass("form-error");
              if (event.data.country === 'es') {
                $(this).parent().append("<div class='error'>Por favor, introduzca una dirección de correo electrónico válida.</div>");
              } else if (event.data.country === 'it') {
                $(this).parent().append("<div class='error'>Inserisci un indirizzo email valido.</div>");
              } else if (event.data.country === 'en') {
                $(this).parent().append("<div class='error'>Please enter a valid email address.</div>");
              } else {
                $(this).parent().append("<div class='error'>Veuillez renseigner une adresse email valide.</div>");
              }
              $(".error").fadeIn();
            } else {
              $(this).addClass("valid");
            }
          } else if (name == "telephone") {
            var iti = event.data.iti;
            var input = document.querySelector("#edit-telephone");
            if (input.value.trim()) {
              // if number is not valid
              if (iti.isValidNumber()) {
                $(this).addClass("valid");
                iti.setNumber(input.value);
                var countryData = iti.getSelectedCountryData();
                $('.edit-telephone-format').val('+' + countryData.dialCode + input.value)
              } else {
                nbChampVide++;
                $(this).addClass("form-error");
                if ($(this).attr('placeholder')) {
                  if (event.data.country === 'es') {
                    $(this).parent().append("<div class='error'>Por favor, introduzca un número de teléfono válido. (Ejemplo : " + $(this).attr('placeholder') + ")</div>");
                  } else if (event.data.country === 'it') {
                    $(this).parent().append("<div class='error'>Si prega di inserire un numero di telefono valido. (Esempio : " + $(this).attr('placeholder') + ")</div>");
                  } else if (event.data.country === 'en') {
                    $(this).parent().append("<div class='error'>Please enter a valid telephone number. (Example : " + $(this).attr('placeholder') + ")</div>");
                  } else {
                    $(this).parent().append("<div class='error'>Veuillez renseigner un numéro de téléphone valide. (Exemple : " + $(this).attr('placeholder') + ")</div>");
                  }
                } else {
                  iti.setCountry(event.data.country);
                  $("#edit-pays").val(event.data.country);
                  if (event.data.country === 'es') {
                    $(this).parent().append("<div class='error'>Por favor, introduzca un número de teléfono válido. (Ejemplo : " + $(this).attr('placeholder') + ")</div>");
                  } else if (event.data.country === 'it') {
                    $(this).parent().append("<div class='error'>Si prega di inserire un numero di telefono valido. (Esempio : " + $(this).attr('placeholder') + ")</div>");
                  } else if (event.data.country === 'en') {
                    $(this).parent().append("<div class='error'>Please enter a valid telephone number. (Example : " + $(this).attr('placeholder') + ")</div>");
                  } else {
                    $(this).parent().append("<div class='error'>Veuillez renseigner un numéro de téléphone valide. (Exemple : " + $(this).attr('placeholder') + ")</div>");
                  }
                }
                $(".error").fadeIn();
              }
            }
          } else if (name == "code_postal") {
            var ISO = $("#edit-pays").val();
            var json = $.getJSON({'url': '/themes/custom/akena/js/libs/postalCode.json', 'async': false});
            apiResponseJsonObj = JSON.parse(json.responseText);
            var regexPostCode = new RegExp(apiResponseJsonObj[0][ISO]['regex']);
            var zipCodeInput = $("#edit-code-postal");

            if (regexPostCode.test($.trim($("#edit-code-postal").val())) == false) {
              nbChampVide++;
              zipCodeInput.addClass("form-error");
              if (event.data.country === 'es') {
                zipCodeInput.parent().append("<div class='error'>Introduzca un código postal válido. (Ejemplo : " + apiResponseJsonObj[0][ISO]['format'] + ")</div>");
              } else if (event.data.country === 'it') {
                zipCodeInput.parent().append("<div class='error'>Inserisci un codice postale valido. (Esempio : " + apiResponseJsonObj[0][ISO]['format'] + ")</div>");
              } else if (event.data.country === 'en') {
                zipCodeInput.parent().append("<div class='error'>Enter a valid postal code. (Example : " + apiResponseJsonObj[0][ISO]['format'] + ")</div>");
              } else {
                zipCodeInput.parent().append("<div class='error'>Veuillez renseigner un code postal valide. (Exemple : " + apiResponseJsonObj[0][ISO]['format'] + ")</div>");
              }
              $(".error").fadeIn();
            } else {
              $(this).addClass("valid");
            }
          } else {
            $(this).addClass("valid");
          }
        }
      }
    });

    // Champ Textarea
    $("textarea:not(.webform-submission-contact-add-form .edit-actions-submit)").each(function () {
      if ($(this).attr("required") == "required") {
        var textError = $(this).attr("data-webform-required-error");
        if ($(this).val() == "" || $(this).val() == " ") {
          // On vérifie que le champ n'est pas vide
          nbChampVide++;
          $(this).addClass("form-error");
          $(this).parent().append("<div class='error'>" + textError + "</div>");
          $(".error").fadeIn();
        }
      }
    });

    // On vérifie que reCaptcha
    if ($("input[name$='recapcha']").length) {
      var recapcha = $("input[name$='recapcha']").val();
      if (recapcha == "true") {
        var $captcha = $(".g-recaptcha"),
          response = grecaptcha.getResponse();
        if (response.length === 0) {
          if (event.data.country === 'es') {
            $(".g-recaptcha").after("<div class='error'>Por favor, compruebe el captcha requerido.</div>");
          } else if (event.data.country === 'it') {
            $(".g-recaptcha").after("<div class='error'>Seleziona il captcha richiesto.</div>");
          } else if (event.data.country === 'it') {
            $(".g-recaptcha").after("<div class='error'>Select the required captcha.</div>");
          } else{
            $(".g-recaptcha").after("<div class='error'>Veuillez cocher le captcha obligatoire.</div>");
          }
          nbChampVide++;
        } else {
          $(".msg-error").text("");
          $captcha.removeClass("error");
        }
      }
    }

    if ($("[id^=edit-rgpd]").length) {
      var consentment = $("[id^=edit-rgpd]").prop("checked");
      if (consentment === false) {
        if (event.data.country === 'es') {
          $(".form-item-rgpd").after("<div class='rgpd-error'>Por favor, marque la casilla para validar su consentimiento a los datos recogidos.</div>");
        } else if (event.data.country === 'it') {
          $(".form-item-rgpd").after("<div class='rgpd-error'>Seleziona la casella per confermare il tuo consenso alla raccolta dei dati.</div>");
        } else if (event.data.country === 'en') {
          $(".form-item-rgpd").after("<div class='rgpd-error'>Check the box to confirm your consent to data collection.</div>");
        } else {
          $(".form-item-rgpd").after("<div class='rgpd-error'>Merci de cocher la case pour valider votre consentement aux données collectées.</div>");
        }
        nbChampVide++;
      }
    }

    if (nbChampVide != 0) {
      event.preventDefault();
      $("body").addClass("loader");
      $(".webform-message-form-error").remove();
      if (event.data.country === 'es') {
        $(this).parent().closest(".webform-submission-form").before('<div class="webform-message-form-error"> <div role="contentinfo" aria-label="error"> <div role="alert"> Se han encontrado ' + nbChampVide + ' errores </div></div></div>');
      } else if (event.data.country === 'it') {
        $(this).parent().closest(".webform-submission-form").before('<div class="webform-message-form-error"> <div role="contentinfo" aria-label="error"> <div role="alert"> Sono stati trovati ' + nbChampVide + ' errori :</div></div></div>');
      } else if (event.data.country === 'en') {
        $(this).parent().closest(".webform-submission-form").before('<div class="webform-message-form-error"> <div role="contentinfo" aria-label="error"> <div role="alert">' + nbChampVide + ' Errors were found :</div></div></div>');
      } else{
        $(this).parent().closest(".webform-submission-form").before('<div class="webform-message-form-error"> <div role="contentinfo" aria-label="error"> <div role="alert">' + nbChampVide + ' erreurs ont été trouvées :</div></div></div>');
      }
      $("html, body").animate({scrollTop: $(".webform-message-form-error").offset().top - 120}, 500);
      $("body").removeClass("loader");
    } else {
      $("body").addClass("loader");
    }
  }

}(jQuery, Drupal, drupalSettings));
